var rxp = new RegExp("(([0-9]+\.?[0-9]+)|[0-9]+)", "gm");

jQuery(document).ready(function(){
	initNumberAutoIncrement();
})

function initNumberAutoIncrement(){
	jQuery('.wp-block-ic-blocks-number-autoincrement').each(function(){
		let currentWidget = jQuery(this);
		let thousand_char = currentWidget.data("thousand-char") ? currentWidget.data("thousand-char") : " ";
		let decimal_char = currentWidget.data("decimal-char") ? currentWidget.data("decimal-char") : ",";
		let time = parseInt(currentWidget.data("time")) ? parseInt(currentWidget.data("time"))*1000 : 1000;
		let show = currentWidget.data('show') ? currentWidget.data('show') : false;

		/*currentWidget.removeAttr("data-thousand-char");
		currentWidget.removeAttr("data-decimal-char");
		currentWidget.removeAttr("data-time");
		currentWidget.removeAttr("data-show");*/

		jQuery(this).html(currentWidget.html().replaceAll(rxp, "<span class=\"ic-blocks-number-autoincrement-item\">$1</span>"))
		currentWidget.find('.ic-blocks-number-autoincrement-item').each(function(){
			let numberAutoIncrementObject = new NumberAutoIncrementFront(this);
			numberAutoIncrementObject.decimal_char = decimal_char;
			numberAutoIncrementObject.thousand_char = thousand_char;
			numberAutoIncrementObject.animation_duration = time;
			numberAutoIncrementObject.play_only_one_time = show!==true;
			jQuery(window).scroll(function(){
				checkNumber(currentWidget, numberAutoIncrementObject);
			})
			checkNumber(currentWidget, numberAutoIncrementObject)
		})
	})
}


function checkNumber(currentWidget, numberAutoIncrementObject) {
	let widgetTop = currentWidget.offset().top;
	let widgetHeight = currentWidget.outerHeight(true);
	let scrollTop = jQuery(window).scrollTop();
	let windowHeight = jQuery(window).outerHeight(true);
	if (widgetTop < scrollTop + windowHeight && widgetTop + widgetHeight > scrollTop) numberAutoIncrementObject.start();
	else numberAutoIncrementObject.reset();
}

/**
 * Create Auto Increment Number with this class
 * @param { container } span contain number
 */

function NumberAutoIncrementFront(container){
	this.decimal_char = ",";
	this.thousand_char = " ";

	this.number = 0;
	this.temp_number = 0;
	this.step_number = 0;

	this.animation_duration = 2000;
	this.animation_step = 150;

	this.interval = null;

	this.play_only_one_time = false;
	this.have_been_play = false;

	this.set_decimal_char = function(decimal_char){
		this.decimal_char = decimal_char;
	}
	this.set_thousand_char = function(thousand_char){
		this.thousand_char = thousand_char;
	}
	this.set_animation_duration = function(animation_duration){
		this.animation_duration = animation_duration;
		this.reset();
	}

	this.start = function(){
		let currentInstance = this;
		if(!this.have_been_play || !this.play_only_one_time){
			clearInterval(this.interval)
			this.interval = setInterval(
				function(){currentInstance.next()},
				this.animation_step
			);
		}
	}
	this.stop = function(){
		clearInterval(this.interval);
		this.interval = null;
		this.display(this.number);
	}
	this.reset = function(){
		this.stop();
		this.temp_number = 0;
		this.display((this.have_been_play && this.play_only_one_time) ? this.number : this.temp_number);
		let total_step = Math.floor(this.animation_duration/this.animation_step);
		this.step_number = this.number/total_step;
	}
	this.next = function(){
		this.have_been_play = true;
		this.temp_number += this.step_number;
		let displayNumber = Math.floor(this.temp_number);
		if(this.temp_number>this.number){
			this.temp_number=this.number;
			displayNumber = this.number;
			this.stop();
		}
		this.display(displayNumber);
	}
	this.display = function(display_number){
		const display_number_splited = display_number.toString().split(".");
		let int_part = display_number_splited[0];
		let float_part = display_number_splited[1] ? display_number_splited[1] : null;
		let display_number_with_separator = int_part.toString().replace(/\B(?=(\d{3})+(?!\d))/g, (this.thousand_char!=="« »"?this.thousand_char:" "));
		display_number_with_separator += float_part!==null ? this.decimal_char+float_part  : "";
		this.container.text(display_number_with_separator);
	}
	this.build = function(){
		this.container = jQuery(container);
		this.number = parseFloat(this.container.text().replaceAll(',','.'));
		jQuery('.slider').each((item)=>{
			if(!jQuery(item).has(this.container).length) this.temp_number = this.number;
		})
		this.display(this.temp_number);
		let total_step = Math.floor(this.animation_duration/this.animation_step);
		this.step_number = this.number/total_step;
	}
	if(!(this instanceof NumberAutoIncrementFront)){
		return new NumberAutoIncrementFront(container);
	}
	this.build();
}
